import React from "react";

const CoachingStaffContext = React.createContext({});

export default CoachingStaffContext;
